export default __webpack_public_path__ + "static/media/aperture.0ca0c23f.svg";